"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLoggerDependencies = useLoggerDependencies;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = require("react");

var _logger = require("../utils/deprecate/logger");

var _excluded = ["scopeName"];
var PRODUCTION_STAGE = process.env.NODE_ENV === 'production';
/**
 * Хук используется для определения лишних перерисовок зависимостей.
 * Код не исполняется production сборке.
 * Функции хука не должны быть размещены в зависимостях хуков,
 * так как это вызывает лишнии перерисовки.
 */

function useLoggerDependencies(_ref) {
  var scopeName = _ref.scopeName,
      props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var previousProps = (0, _react.useRef)({});
  var isRemove = (0, _react.useRef)(false);
  var detectedChangedProps = (0, _react.useCallback)(function () {
    if (!PRODUCTION_STAGE) {
      Object.keys(props).forEach(function (key) {
        if (props[key] !== previousProps.current[key] && isRemove.current) {
          _logger.logger.warn("\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u043E \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u0437\u0430\u0432\u0438\u0441\u0438\u043C\u043E\u0441\u0442\u0438 ".concat(key, ", \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u044B \u043E\u0448\u0438\u0431\u043A\u0438!"), scopeName);

          isRemove.current = false;
        }
      });
      previousProps.current = props;
    }
  }, [props, scopeName]);

  var unmountTrigger = function unmountTrigger() {
    if (!PRODUCTION_STAGE) {
      isRemove.current = true;
    }
  };

  return {
    detectedChangedProps: detectedChangedProps,
    unmountTrigger: unmountTrigger
  };
}